import React from 'react';
import {
  BrowserRouter as Router, Redirect, Route, Switch,
} from 'react-router-dom';
import { Box, styled } from '@mui/material';
import profilePath from 'shared/routes/home';
import { rootPath as ticketRootPath } from 'shared/routes/support';
import { useAuth } from 'shared/hooks';
import connectRoutes from 'shared/hoc/withRoutes';
import Auth from 'features/auth';
import homeModule from 'features/home';
import adminModule from 'features/admin';
import User from 'features/admin/User';
import couponModule from 'features/coupon';
import voucherModule from 'features/voucher';
import buildingModule from 'features/building';
import tenantModule from 'features/tenant';
import networkingModule from 'features/networking';
import supportModule from 'features/support';
import NavBar from 'shared/components/NavBar';
import NotFound from './NotFound';

const withRoutes = connectRoutes([
  homeModule,
  adminModule,
  buildingModule,
  couponModule,
  networkingModule,
  supportModule,
  tenantModule,
  voucherModule,
]);

const ContentWrapper = styled(Box)(({ theme }) => ({
  marginLeft: `calc(${theme.custom.sideNavWidth} + ${theme.custom.contentMargin})`,
  marginRight: theme.custom.contentMargin,
  marginTop: theme.custom.mainNavHeight,
  marginBottom: '1rem',
  [theme.breakpoints.down('md')]: {
    marginLeft: theme.custom.contentMargin,
    marginBottom: theme.custom.mainNavHeight,
  },
}));

/**
 * @param {Object} props
 * @param {Array<Object>} props.enabledRoutes
 * @param {boolean} props.routesLoaded
 */
function AppRouter(props) {
  const { enabledRoutes, routesLoaded } = props;
  const { isLoggedIn } = useAuth();
  return (
    <Router>
      <NavBar routes={enabledRoutes} />
      <Auth />
      <ContentWrapper>
        <Switch>
          {enabledRoutes.map(({ rootPath, RouteComponent }) => (
            <Route
              component={RouteComponent}
              exact={rootPath === '/'}
              key={rootPath}
              path={rootPath}
            />
          ))}
          <Route
            render={() => isLoggedIn && <User />}
            path={profilePath}
          />
          {/* The header calls the ticket module "Support". */}
          <Redirect exact from="/support" to={ticketRootPath} />
          <Route render={() => isLoggedIn && routesLoaded && <NotFound />} />
        </Switch>
      </ContentWrapper>
    </Router>
  );
}

export default withRoutes(AppRouter);
